import SvgIconWrapper from "./SvgIconWrapper";

export default function NoticeIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <SvgIconWrapper {...props}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.9635 21.2457C32.4889 21.2423 32.0839 21.053 31.8053 20.7346C31.5383 20.4294 31.42 20.0442 31.42 19.6824C31.42 19.3205 31.5383 18.9354 31.8052 18.6301C32.0836 18.3117 32.4884 18.1221 32.963 18.1184L32.9685 18.1183L38.1565 18.1184C38.6312 18.1218 39.0361 18.3111 39.3147 18.6295C39.5818 18.9347 39.7 19.3199 39.7 19.6818C39.7 20.0436 39.5818 20.4287 39.3148 20.734C39.0364 21.0524 38.6316 21.242 38.157 21.2457L38.1515 21.2458L32.9635 21.2457Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.596 9.07989L31.0132 11.6626C30.4908 12.1538 30.4538 12.8513 30.6694 13.3699C30.8845 13.8875 31.4039 14.3539 32.1167 14.3345C32.5221 14.3314 32.9043 14.1719 33.1992 13.8923L33.2059 13.8859L35.8039 11.2878C36.4142 10.6776 36.4142 9.69015 35.8039 9.07989C35.1937 8.46963 34.2063 8.46963 33.596 9.07989Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.5879 30.2923L33.5879 30.2924L33.5906 30.2951C33.9293 30.63 34.3511 30.7816 34.7735 30.7523C35.178 30.7242 35.5337 30.5348 35.7893 30.2792C36.0449 30.0237 36.2348 29.6674 36.261 29.2616C36.2883 28.838 36.1323 28.4179 35.7946 28.0831L33.2043 25.4929C32.5941 24.8827 31.6067 24.8827 30.9964 25.4929C30.3861 26.1032 30.3861 27.0906 30.9964 27.7009L33.5879 30.2923ZM31.3823 26.1209C31.1596 26.4556 31.1959 26.9104 31.4914 27.2059L34.0829 29.7974C34.4971 30.207 35.0216 30.0816 35.3223 29.7551C35.0216 30.0816 34.4971 30.207 34.0829 29.7974L31.4914 27.2059C31.1959 26.9104 31.1596 26.4556 31.3823 26.1209Z"
          fill="currentColor"
        />
        <path
          d="M21.1165 31.2227C21.4186 31.5078 23.2845 33.7534 23.6562 33.9089C25.3317 35.1099 27.8455 33.7794 27.7856 31.7062V7.65717C27.8463 5.56698 25.2888 4.23641 23.6133 5.48032C22.2746 6.64649 20.7975 8.7626 19.3543 9.7992C16.6503 12.0886 13.1696 13.3844 9.64516 13.6087V25.7538C10.915 25.8575 12.1848 26.03 13.4028 26.4017C16.3571 27.248 19.0523 28.9503 21.1165 31.2219V31.2227Z"
          fill="currentColor"
        />
        <path
          d="M1.08433 22.1865C1.43823 24.1908 3.27819 25.7457 5.32546 25.7279H7.91695V13.6346H5.32546C2.9421 13.6346 1.00659 15.5701 1.00659 17.9543C1.0325 18.5592 0.937752 21.6601 1.08433 22.1873V22.1865Z"
          fill="currentColor"
        />
        <path
          d="M5.32628 27.4561C4.72133 27.4561 4.1431 27.3614 3.59889 27.2059V31.7758C3.68555 35.1876 8.69521 35.1966 8.78186 31.7758V27.4569H5.32628V27.4561Z"
          fill="currentColor"
        />
      </svg>
    </SvgIconWrapper>
  );
}
